import React from "react";
import { connect } from "react-redux";
import { Typography, Button, Grid } from "@material-ui/core";
import {
    StyledCard,
    StyledContent,
    StyledViewContainer,
    StyledHeader,
} from "../../styles";

import { Print as PrintIcon } from "@material-ui/icons";
import {
    getRequesting,
    selectProfile,
    selectToolType,
    getUserIcons,
} from "./selectors";
import ReactToPrint from "react-to-print";
import {
    AttachedImages,
    GeneralDetails,
    MapView,
    ToolboxReports,
    TalkingPoints,
} from "./Widgets";
import { getToolBox, setToolbox, uploadFile } from "./actions";
import { Modal, ModalBody, Spinner } from "reactstrap";

class ToolBoxReport extends React.Component {
    constructor(props) {
        super(props);

        let toolbox_id = props.match.params.uid;
        let report_ts = props.match.params.timestamp
            .replace(/_/g, " ")
            .replace(/\./g, ":");
        // if (pageType === "new") {
        //     let id = Date.now().toString();

        // } else {

        // }

        this.state = {
            pageType: props.match.params.type,
            toolbox_id,
            report_ts,
            toolbox: false,
        };
        props.getToolBox(toolbox_id);
    }
    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.pageType !== "new" &&
            this.props.toolbox !== this.state.toolbox
        ) {
            this.setState({ toolbox: this.props.toolbox });
        }
    }
    render() {
        const {
            toolbox: { profile = false, reports = false, points = [] } = false,
        } = this.state;

        return (
            <StyledCard style={{ paddingBottom: "0px" }}>
                <React.Fragment>
                    <StyledHeader>
                        <Typography
                            variant="h5"
                            style={{ width: "50%", display: "inline" }}
                        >
                            ToolBox Report
                        </Typography>
                        <ReactToPrint
                            style={{}}
                            onBeforePrint={() => {
                                setTimeout(undefined, 2000);
                                document.title =
                                    "Toolbox Report - " +
                                    profile.toolbox_topic +
                                    " - " +
                                    this.state.report_ts
                                        .replace(/_/g, " ")
                                        .replace(/\./g, ":");
                            }}
                            onAfterPrint={() => {}}
                            trigger={() => (
                                <Button
                                    style={{
                                        float: "right",
                                        color: "white",
                                        background: "#0188cc",
                                    }}
                                    color="primary"
                                    variant="contained"
                                    size="small"
                                >
                                    <PrintIcon /> Print
                                </Button>
                            )}
                            content={() => this.componentRef}
                        />
                    </StyledHeader>
                    <br />
                    {this.state.toolbox && (
                        <StyledContent style={{ paddingTop: "0px" }}>
                            <Modal
                                isOpen={this.props.requesting}
                                style={{ maxWidth: "00px" }}
                            >
                                <ModalBody>
                                    <div
                                        style={{
                                            textAlign: "center",
                                            paddingTop: "3em",
                                        }}
                                    >
                                        <div
                                            style={{
                                                background: "white",
                                                width: "fit-content",
                                                display: "inline-block",
                                                padding: "2em",
                                            }}
                                        >
                                            <Spinner
                                                style={{
                                                    height: 100,
                                                    width: 100,
                                                    background: "white",
                                                }}
                                                color="primary"
                                            />
                                            <Typography
                                                style={{
                                                    textAlign: "center",
                                                    marginTop: 15,
                                                    color:
                                                        "rgba(0, 0, 0, 0.87)",
                                                    fontWeight: "bolder",
                                                    fontSize: 20,
                                                }}
                                                variant="body2"
                                            >
                                                Processing...
                                            </Typography>
                                        </div>
                                    </div>
                                </ModalBody>
                            </Modal>

                            <StyledViewContainer
                                style={{ paddingTop: "0px" }}
                                ref={(el) => (this.componentRef = el)}
                            >
                                <Grid container spacing={3}>
                                    <Grid
                                        item
                                        xs={6}
                                        sm={6}
                                        md={6}
                                        lg={6}
                                        xl={6}
                                    >
                                        <Grid container spacing={2}>
                                            <GeneralDetails
                                                profile={profile}
                                                report={
                                                    reports
                                                        ? reports[
                                                              this.state
                                                                  .report_ts
                                                          ]
                                                        : false
                                                }
                                            />
                                            <AttachedImages profile={profile} />
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={6}
                                        sm={6}
                                        md={6}
                                        lg={6}
                                        xl={6}
                                    >
                                        <MapView
                                            report={
                                                reports
                                                    ? reports[
                                                          this.state.report_ts
                                                      ]
                                                    : false
                                            }
                                        />
                                    </Grid>
                                    <TalkingPoints points={points} />
                                    <ToolboxReports
                                        report={
                                            reports
                                                ? reports[this.state.report_ts]
                                                : false
                                        }
                                        userIcons={this.props.userIcons}
                                    />
                                </Grid>
                            </StyledViewContainer>
                        </StyledContent>
                    )}
                </React.Fragment>
            </StyledCard>
        );
    }
}

export default connect(
    (store) => {
        return {
            requesting: getRequesting(store),
            toolbox: selectProfile(store),
            toolboxTypes: selectToolType(store),
            userIcons: getUserIcons(store),
        };
    },
    {
        uploadFile,

        getToolBox,
        setToolbox,
    }
)(ToolBoxReport);
